import { useState, useEffect } from 'react';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import config from '../../../../utils/EnvironmentSwitcher';
import { auth } from '../../../firebase/firebase';
export const useStripeConnect = (accountId) => {
      const [hasError, setHasError] = useState(false);
      const [stripeConnectInstance, setStripeConnectInstance] = useState(null);

      useEffect(() => {
            const initializeStripeConnect = async () => {
                  try {
                        const fetchClientSecret = async () => {
                              try {
                                    const idToken = await auth.currentUser?.getIdToken();
                                    const response = await fetch(`${config.paymentUrl}/account_session`, {
                                          method: 'POST',
                                          headers: {
                                                'Content-Type': 'application/json',
                                                ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
                                          },
                                          body: JSON.stringify({
                                                account: accountId
                                          })
                                    });

                                    if (!response.ok) {
                                          const error = await response.json();
                                          console.error('Account session error:', error);
                                          return null;
                                    }

                                    const data = await response.json();
                                    if (!data.client_secret) {
                                          console.error('No client secret returned');
                                          return null;
                                    }

                                    return data.client_secret;
                              } catch (error) {
                                    console.error('Error fetching client secret:', error);
                                    return null;
                              }
                        };

                        const instance = await loadConnectAndInitialize({
                              publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
                              fetchClientSecret: fetchClientSecret,
                        });

                        setStripeConnectInstance(instance);
                  } catch (error) {
                        console.error('Failed to load Stripe Connect:', error);
                        setHasError(true);
                  }
            };

            if (accountId) {
                  initializeStripeConnect();
            }
      }, [accountId]);

      return { hasError, stripeConnectInstance };
}; 